import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import { getPhoenixFormVersion} from "requests/homeowner/caseforms";
import MSpinner from "components/Shared/MSpinner.tsx";
import REOMITV0 from "components/Homeowner/CaseForms/REOMIT/V0/REOMITV0";
import REOMITV2 from "components/Homeowner/CaseForms/REOMIT/V2/REOMITV2";

export const ReoMit = props => {
  const mounted = useRef(true);

  const [version, setVersion] = useState();
  const [isFetchingVersion, setIsFetchingVersion] = useState(false);

  useEffect(() => {
    getPhoenixFormVersion(props.controlNumber, (payload) => {
      setVersion(payload);
      setIsFetchingVersion(false);
    }, mounted);
    return (() => { mounted.current = false; });
  }, []);

  if (isFetchingVersion || version === undefined) return <MSpinner />;
  
  // I'm skipping V1, I want the PNX form name to match the React form name moving forward
  let versionedComponents = [REOMITV0, REOMITV0, REOMITV2];
  let MyComponent = versionedComponents[version];
  if (!MyComponent) {
    throw new Error(`No corresponding 1004p frontend version for backend version: ${version}`);
  }

  return (<MyComponent 
            controlNumber={props.controlNumber} 
            onChange={props.onChange}
            onSave={props.onSave}
            readOnly={props.readOnly}
          />);
};

ReoMit.propTypes = {
  controlNumber: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  readOnly: PropTypes.bool
};

export default ReoMit;
